import * as React from 'react';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import './ProjectDetails.css';
import HRGrid from './HRGrid';

export default function HR(props) {
    const {isSmallScreen, course} = props;
    const [spacing, setSpacing] = React.useState(2);

    const handleChange = (event) => {
        setSpacing(Number(event.target.value));
    };

    return (
        <div style={{ margin: isSmallScreen ? "4rem auto auto 20px" : "60px", marginBottom: "0px" }}>
            <span className={isSmallScreen ? 'only-heading-sm' : 'only-heading'}>Insights from  </span>
            <span className={isSmallScreen ? 'gradient-heading-sm' : 'gradient-heading'}>Our Hiring Partners</span>
            <div style={{ display: "flex", marginTop: "0rem" }}>
                <HRGrid isSmallScreen={isSmallScreen} course={course}/>
            </div>
        </div>
    );
}